var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c("BatchesFilters", {
        attrs: {
          value: _vm.filters,
          onChange: _vm.onChangeFiltersHistory,
          clear: _vm.clearFiltersHistory,
          "is-history": true
        }
      }),
      _c(
        "div",
        {
          staticClass:
            "text-left mb-2 d-flex justify-content-start align-items-center"
        },
        [
          _c(
            "b-button",
            {
              staticClass: "ml-4 badge-glow",
              attrs: { variant: "warning", size: "sm", "data-cy": "download" },
              on: { click: _vm.onDownloadHistory }
            },
            [
              _c("feather-icon", {
                staticClass: "mr-3",
                attrs: { icon: "DownloadIcon" }
              }),
              _c("span", { staticClass: "align-middle" }, [_vm._v("Descargar")])
            ],
            1
          )
        ],
        1
      ),
      _c("BatchesHeader"),
      _c(
        "div",
        { key: _vm.forceRender, staticClass: "force-render" },
        _vm._l(_vm.filteredAuctionsBatchesHistory, function(auctionBatch) {
          return _c("AuctionHistoryRow", {
            key: auctionBatch.loteId,
            attrs: {
              auctionBatch: auctionBatch,
              "select-batch": _vm.selectBatch,
              "data-cy": "file"
            },
            on: { "reload-list": _vm.handleReloadList }
          })
        }),
        1
      ),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-3" }, [
          _c("div", { staticClass: "mt-5" }, [
            _vm._v(" Mostrando "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rowspp,
                    expression: "rowspp"
                  }
                ],
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.rowspp = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    function($event) {
                      return _vm.fetchAuctionsHistory()
                    }
                  ]
                }
              },
              [
                _c("option", { attrs: { value: "10", selected: "selected" } }, [
                  _vm._v("10 ")
                ]),
                _c("option", { attrs: { value: "15" } }, [_vm._v("15")]),
                _c("option", { attrs: { value: "30" } }, [_vm._v("30")]),
                _c("option", { attrs: { value: "50" } }, [_vm._v("50")])
              ]
            ),
            _vm._v(" registros por página. ")
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-9" },
          [
            _c("AuctionsPagination", {
              attrs: { show: _vm.filteredAuctionsBatchesHistory.length },
              model: {
                value: _vm.page,
                callback: function($$v) {
                  _vm.page = $$v
                },
                expression: "page"
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }